// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─── Page Layout ──────────────────────────────────────────────────────────── */

.rAa_kos_page {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* ─── Header ───────────────────────────────────────────────────────────────── */

.rAa_kos_header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.rAa_kos_title-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}

.rAa_kos_header-icon {
  width: 24px;
  height: 24px;
  color: #0860e6;
  flex-shrink: 0;
}

.rAa_kos_title {
  font-size: 22px;
  font-weight: 700;
  color: #0b0b0b;
  margin: 0;
}

.rAa_kos_subtitle {
  font-size: 13px;
  color: #6b6b6b;
  margin: 0;
}

/* ─── Toolbar ──────────────────────────────────────────────────────────────── */

.rAa_kos_toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.rAa_kos_filter-btn-wrapper {
  position: relative;
}

.rAa_kos_filter-badge {
  position: absolute;
  top: -6px;
  right: -6px;
  min-width: 18px;
  height: 18px;
  background: #1976d2;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  padding: 0 3px;
}

/* ─── Tabs ─────────────────────────────────────────────────────────────────── */

.rAa_kos_tabs {
  display: flex;
  border-bottom: 1.5px solid #e6e6e6;
  gap: 0;
}

.rAa_kos_tab {
  background: none;
  border: none;
  border-bottom: 2.5px solid transparent;
  margin-bottom: -1.5px;
  padding: 10px 18px;
  font-size: 14px;
  font-weight: 500;
  color: #6b6b6b;
  cursor: pointer;
  white-space: nowrap;
  transition: color 0.15s, border-color 0.15s;
}

.rAa_kos_tab:hover {
  color: #0b0b0b;
}

.rAa_kos_tab-active {
  color: #0860e6;
  border-bottom-color: #0860e6;
  font-weight: 600;
}

/* ─── Stat Cards ───────────────────────────────────────────────────────────── */

.rAa_kos_stat-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
}

.rAa_kos_stat-card {
  background: #ffffff;
  border: 1px solid #e6e6e6;
  border-radius: 10px;
  padding: 20px 22px;
}

.rAa_kos_stat-card-alert {
  border-left: 4px solid #e90000;
}

.rAa_kos_stat-label {
  font-size: 13px;
  color: #6b6b6b;
  margin: 0 0 8px 0;
}

.rAa_kos_stat-value {
  font-size: 28px;
  font-weight: 700;
  color: #0b0b0b;
  margin: 0 0 6px 0;
  line-height: 1.1;
}

.rAa_kos_stat-value-red {
  color: #e90000;
}

.rAa_kos_stat-value-orange {
  color: #eba85a;
}

.rAa_kos_stat-value-green {
  color: #219647;
}

.rAa_kos_stat-sub {
  font-size: 12px;
  color: #6b6b6b;
  margin: 0;
}

/* ─── Table Card ───────────────────────────────────────────────────────────── */

.rAa_kos_table-card {
  background: #ffffff;
  border: 1px solid #e6e6e6;
  border-radius: 10px;
  padding: 20px;
}

.rAa_kos_table-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 16px;
}

.rAa_kos_table-title {
  font-size: 15px;
  font-weight: 600;
  color: #0b0b0b;
  margin: 0 0 4px 0;
}

.rAa_kos_table-subtitle {
  font-size: 12px;
  color: #6b6b6b;
  margin: 0;
}

.rAa_kos_table-scroll {
  overflow-x: auto;
}

.rAa_kos_no-results {
  text-align: center;
  font-size: 13px;
  color: #949494;
  padding: 24px 0;
}

/* ─── Fill Rate Badge ──────────────────────────────────────────────────────── */

.rAa_kos_fill-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
}

.rAa_kos_fill-green {
  background: #e6f6ec;
  color: #219647;
}

.rAa_kos_fill-yellow {
  background: #fdf3e3;
  color: #c87a00;
}

.rAa_kos_fill-red {
  background: #fdecea;
  color: #e90000;
}

/* ─── QC Status ────────────────────────────────────────────────────────────── */

.rAa_kos_qc-passed {
  font-size: 13px;
  font-weight: 500;
  color: #219647;
}

.rAa_kos_qc-warning {
  font-size: 13px;
  font-weight: 500;
  color: #c87a00;
}

/* ─── ID Link ──────────────────────────────────────────────────────────────── */

.rAa_kos_id-link {
  color: #0860e6;
  font-weight: 500;
  font-size: 13px;
  cursor: pointer;
}

.rAa_kos_id-link:hover {
  text-decoration: underline;
}

/* ─── High Rejects ─────────────────────────────────────────────────────────── */

.rAa_kos_high-rejects {
  color: #e90000;
  font-weight: 600;
}

/* ─── Category Colors ──────────────────────────────────────────────────────── */

.rAa_kos_category-vegetables {
  color: #219647;
  font-weight: 500;
}

.rAa_kos_category-proteins {
  color: #c87a00;
  font-weight: 500;
}

.rAa_kos_category-sauces {
  color: #0860e6;
  font-weight: 500;
}

.rAa_kos_category-prepared {
  color: #7c3aed;
  font-weight: 500;
}

/* ─── Cost Impact ──────────────────────────────────────────────────────────── */

.rAa_kos_cost-impact {
  color: #e90000;
  font-weight: 600;
  font-size: 13px;
}

/* ─── Invoice Status Badge ─────────────────────────────────────────────────── */

.rAa_kos_invoice-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
}

.rAa_kos_status-settled {
  background: #e6f6ec;
  color: #219647;
}

.rAa_kos_status-outstanding {
  background: #fdf3e3;
  color: #c87a00;
}

.rAa_kos_status-overdue {
  background: #fdecea;
  color: #e90000;
}

/* ─── Action Link ──────────────────────────────────────────────────────────── */

.rAa_kos_action-link {
  background: none;
  border: none;
  color: #0860e6;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  padding: 0;
}

.rAa_kos_action-link:hover {
  text-decoration: underline;
}

/* ─── Responsive ───────────────────────────────────────────────────────────── */

@media (max-width: 900px) {
  .rAa_kos_header {
    flex-direction: column;
    align-items: flex-start;
  }

  .rAa_kos_title {
    font-size: 18px;
  }

  .rAa_kos_stat-cards {
    grid-template-columns: 1fr 1fr;
  }

  .rAa_kos_tabs {
    overflow-x: auto;
  }
}

@media (max-width: 640px) {
  .rAa_kos_title {
    font-size: 16px;
  }

  .rAa_kos_stat-cards {
    grid-template-columns: 1fr;
  }

  .rAa_kos_tab {
    padding: 8px 12px;
    font-size: 13px;
  }

  .rAa_kos_stat-value {
    font-size: 22px;
  }
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/Kitchen-OS/components/reportsAndAnalysis.css"],"names":[],"mappings":"AAAA,iFAAiF;;AAEjF;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,iFAAiF;;AAEjF;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA,iFAAiF;;AAEjF;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;AAChB;;AAEA,iFAAiF;;AAEjF;EACE,aAAa;EACb,kCAAkC;EAClC,MAAM;AACR;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,sCAAsC;EACtC,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,iFAAiF;;AAEjF;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA,iFAAiF;;AAEjF;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,iFAAiF;;AAEjF;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,iFAAiF;;AAEjF;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,iFAAiF;;AAEjF;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,iFAAiF;;AAEjF;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,iFAAiF;;AAEjF;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,iFAAiF;;AAEjF;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,iFAAiF;;AAEjF;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,iFAAiF;;AAEjF;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,iFAAiF;;AAEjF;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* ─── Page Layout ──────────────────────────────────────────────────────────── */\n\n.rAa_kos_page {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* ─── Header ───────────────────────────────────────────────────────────────── */\n\n.rAa_kos_header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.rAa_kos_title-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 4px;\n}\n\n.rAa_kos_header-icon {\n  width: 24px;\n  height: 24px;\n  color: #0860e6;\n  flex-shrink: 0;\n}\n\n.rAa_kos_title {\n  font-size: 22px;\n  font-weight: 700;\n  color: #0b0b0b;\n  margin: 0;\n}\n\n.rAa_kos_subtitle {\n  font-size: 13px;\n  color: #6b6b6b;\n  margin: 0;\n}\n\n/* ─── Toolbar ──────────────────────────────────────────────────────────────── */\n\n.rAa_kos_toolbar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.rAa_kos_filter-btn-wrapper {\n  position: relative;\n}\n\n.rAa_kos_filter-badge {\n  position: absolute;\n  top: -6px;\n  right: -6px;\n  min-width: 18px;\n  height: 18px;\n  background: #1976d2;\n  color: #fff;\n  font-size: 11px;\n  font-weight: 600;\n  border-radius: 9px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n  padding: 0 3px;\n}\n\n/* ─── Tabs ─────────────────────────────────────────────────────────────────── */\n\n.rAa_kos_tabs {\n  display: flex;\n  border-bottom: 1.5px solid #e6e6e6;\n  gap: 0;\n}\n\n.rAa_kos_tab {\n  background: none;\n  border: none;\n  border-bottom: 2.5px solid transparent;\n  margin-bottom: -1.5px;\n  padding: 10px 18px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #6b6b6b;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: color 0.15s, border-color 0.15s;\n}\n\n.rAa_kos_tab:hover {\n  color: #0b0b0b;\n}\n\n.rAa_kos_tab-active {\n  color: #0860e6;\n  border-bottom-color: #0860e6;\n  font-weight: 600;\n}\n\n/* ─── Stat Cards ───────────────────────────────────────────────────────────── */\n\n.rAa_kos_stat-cards {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 14px;\n}\n\n.rAa_kos_stat-card {\n  background: #ffffff;\n  border: 1px solid #e6e6e6;\n  border-radius: 10px;\n  padding: 20px 22px;\n}\n\n.rAa_kos_stat-card-alert {\n  border-left: 4px solid #e90000;\n}\n\n.rAa_kos_stat-label {\n  font-size: 13px;\n  color: #6b6b6b;\n  margin: 0 0 8px 0;\n}\n\n.rAa_kos_stat-value {\n  font-size: 28px;\n  font-weight: 700;\n  color: #0b0b0b;\n  margin: 0 0 6px 0;\n  line-height: 1.1;\n}\n\n.rAa_kos_stat-value-red {\n  color: #e90000;\n}\n\n.rAa_kos_stat-value-orange {\n  color: #eba85a;\n}\n\n.rAa_kos_stat-value-green {\n  color: #219647;\n}\n\n.rAa_kos_stat-sub {\n  font-size: 12px;\n  color: #6b6b6b;\n  margin: 0;\n}\n\n/* ─── Table Card ───────────────────────────────────────────────────────────── */\n\n.rAa_kos_table-card {\n  background: #ffffff;\n  border: 1px solid #e6e6e6;\n  border-radius: 10px;\n  padding: 20px;\n}\n\n.rAa_kos_table-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n\n.rAa_kos_table-title {\n  font-size: 15px;\n  font-weight: 600;\n  color: #0b0b0b;\n  margin: 0 0 4px 0;\n}\n\n.rAa_kos_table-subtitle {\n  font-size: 12px;\n  color: #6b6b6b;\n  margin: 0;\n}\n\n.rAa_kos_table-scroll {\n  overflow-x: auto;\n}\n\n.rAa_kos_no-results {\n  text-align: center;\n  font-size: 13px;\n  color: #949494;\n  padding: 24px 0;\n}\n\n/* ─── Fill Rate Badge ──────────────────────────────────────────────────────── */\n\n.rAa_kos_fill-badge {\n  display: inline-block;\n  padding: 3px 10px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.rAa_kos_fill-green {\n  background: #e6f6ec;\n  color: #219647;\n}\n\n.rAa_kos_fill-yellow {\n  background: #fdf3e3;\n  color: #c87a00;\n}\n\n.rAa_kos_fill-red {\n  background: #fdecea;\n  color: #e90000;\n}\n\n/* ─── QC Status ────────────────────────────────────────────────────────────── */\n\n.rAa_kos_qc-passed {\n  font-size: 13px;\n  font-weight: 500;\n  color: #219647;\n}\n\n.rAa_kos_qc-warning {\n  font-size: 13px;\n  font-weight: 500;\n  color: #c87a00;\n}\n\n/* ─── ID Link ──────────────────────────────────────────────────────────────── */\n\n.rAa_kos_id-link {\n  color: #0860e6;\n  font-weight: 500;\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.rAa_kos_id-link:hover {\n  text-decoration: underline;\n}\n\n/* ─── High Rejects ─────────────────────────────────────────────────────────── */\n\n.rAa_kos_high-rejects {\n  color: #e90000;\n  font-weight: 600;\n}\n\n/* ─── Category Colors ──────────────────────────────────────────────────────── */\n\n.rAa_kos_category-vegetables {\n  color: #219647;\n  font-weight: 500;\n}\n\n.rAa_kos_category-proteins {\n  color: #c87a00;\n  font-weight: 500;\n}\n\n.rAa_kos_category-sauces {\n  color: #0860e6;\n  font-weight: 500;\n}\n\n.rAa_kos_category-prepared {\n  color: #7c3aed;\n  font-weight: 500;\n}\n\n/* ─── Cost Impact ──────────────────────────────────────────────────────────── */\n\n.rAa_kos_cost-impact {\n  color: #e90000;\n  font-weight: 600;\n  font-size: 13px;\n}\n\n/* ─── Invoice Status Badge ─────────────────────────────────────────────────── */\n\n.rAa_kos_invoice-badge {\n  display: inline-block;\n  padding: 3px 10px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.rAa_kos_status-settled {\n  background: #e6f6ec;\n  color: #219647;\n}\n\n.rAa_kos_status-outstanding {\n  background: #fdf3e3;\n  color: #c87a00;\n}\n\n.rAa_kos_status-overdue {\n  background: #fdecea;\n  color: #e90000;\n}\n\n/* ─── Action Link ──────────────────────────────────────────────────────────── */\n\n.rAa_kos_action-link {\n  background: none;\n  border: none;\n  color: #0860e6;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  padding: 0;\n}\n\n.rAa_kos_action-link:hover {\n  text-decoration: underline;\n}\n\n/* ─── Responsive ───────────────────────────────────────────────────────────── */\n\n@media (max-width: 900px) {\n  .rAa_kos_header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .rAa_kos_title {\n    font-size: 18px;\n  }\n\n  .rAa_kos_stat-cards {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .rAa_kos_tabs {\n    overflow-x: auto;\n  }\n}\n\n@media (max-width: 640px) {\n  .rAa_kos_title {\n    font-size: 16px;\n  }\n\n  .rAa_kos_stat-cards {\n    grid-template-columns: 1fr;\n  }\n\n  .rAa_kos_tab {\n    padding: 8px 12px;\n    font-size: 13px;\n  }\n\n  .rAa_kos_stat-value {\n    font-size: 22px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
